import React from "react";
import { connect } from "react-redux";
import { Container, Row, Col } from "reactstrap";

import { MyDraggable as Draggable, Dropzone } from "../components/Core";
import HoverBar from "../components/HoverBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { generateStyle, l, setOverLay } from "../functions";
import Icon from "../components/Icons";

const mapStateToProps = (state) => {
  return {
    elementOptions: state.rootReducer.elementOptions || [],
    currentDevice: state.rootReducer.currentDevice || "xl",
    settings: state.rootReducer?.appearanceSettings || {},
  };
};

export class Divider extends React.Component {
  _generateDivider = () => {
    let { payload } = this.props;
    console.log(this.props.payload);
    const {
      dividerLineWidth,
      dividerLineColor,
      dividerLineType,
      dividerSpacingTop,
      dividerSpacingBottom,
    } =
      payload["settings-" + this.props.currentDevice]?.divider ||
      payload?.settings?.divider ||
      {};

    const cssSettings = generateStyle(payload, "container");
    return (
      <>
        <Container fluid={payload.fullContainer}>
          {setOverLay(payload)}
          <Row>
            <div className="divider" style={cssSettings}>
              <div style={{ height: dividerSpacingTop }} />
              <div
                style={{
                  borderTopColor: dividerLineColor,
                  borderTopWidth: dividerLineWidth,
                  borderTopStyle: dividerLineType,
                }}
              />
              <div style={{ height: dividerSpacingBottom }} />
            </div>
          </Row>
        </Container>
      </>
    );
  };
  render() {
    const {
      dropzoneID,
      parentID,
      showBasicContent,
      showPreview,
      id,
      dropzoneProps,
      payload,
      ...rest
    } = this.props;

    const cssSettings = generateStyle(payload, "container");
    if (showBasicContent) {
      return (
        <Draggable {...this.props} side={true}>
          <span className="dragger">
            {(Array.isArray(rest.icon) && (
              <FontAwesomeIcon icon={rest.icon} />
            )) || <Icon icon={rest.icon} />}
            <span>{l(rest.name)}</span>
          </span>
        </Draggable>
      );
    }
    return (
      <Draggable {...this.props} row={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          element={{ id, dropzoneID, parentID, payload }}
        />
        {this._generateDivider()}
      </Draggable>
    );
  }
}

export default connect(mapStateToProps, null)(Divider);
